export default __webpack_public_path__ + "static/media/icon-sun-cloud.3399b234.png";